/* eslint-disable */
import React from 'react';
export var ArrowUp = function (_a) {
    var show = _a.show;
    return React.createElement(React.Fragment, null,
        " ",
        show && React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M13.8633 11.1084C13.6681 11.3037 13.3515 11.3037 13.1562 11.1084L8.21214 6.16437C8.09499 6.04722 7.90504 6.04722 7.78788 6.16437L2.84381 11.1084C2.64855 11.3037 2.33197 11.3037 2.1367 11.1084C1.94144 10.9132 1.94144 10.5966 2.1367 10.4013L7.08077 5.45727C7.58845 4.94959 8.41157 4.94959 8.91925 5.45727L13.8633 10.4013C14.0586 10.5966 14.0586 10.9132 13.8633 11.1084Z", fill: "#0D0F13" })));
};
export default ArrowUp;
